import { render } from "./GerenciarGrupos.vue?vue&type=template&id=c9c4cc62"
import script from "./GerenciarGrupos.vue?vue&type=script&lang=js"
export * from "./GerenciarGrupos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__